module.exports = __webpack_public_path__ + "900b9f1ea9ba7d021ffc40407b06198b.svg";